module.exports = __webpack_public_path__ + "static/media/ok.3f38bbcf.ico";